/// <reference types="@account-verification-frontend/types" />
import * as React from 'react';
import { render } from 'react-dom';
import { TranslatorProvider } from '@wh/ui-translations';
import qs from 'query-string';
import * as translations from './translations';
import { DEFAULT_LOCALE } from './constants';

// Polyfills for IE11

import 'core-js/es/string';
import 'core-js/features/array/includes';

import { VerificationJourney } from '@account-verification-frontend/verification-journey';

import './App.scss';
import { ThemeProvider } from '@sitebase/theme-context';
import { LiveMessagingFlowConfig } from '@central-products/live-messaging-flow';
import { initializeLiveMessaging } from './liveMessaging/initializeLiveMessaging';

// Fire-and-forget: sets up window.WH.bootstrapper.features['live-messaging-flow'] (Genesys chat) for
// this page. The chat click handler (packages/summary) reads window.WH.bootstrapper lazily, so it
// doesn't need to be awaited before rendering. window.avAppConfig['live-messaging-flow'] is loosely
// typed (Record<string, any>) to keep the shared Window.avAppConfig global consistent across all
// packages that declare it — it is validated/shaped as LiveMessagingFlowConfig here, where the real
// dependency on @central-products/live-messaging-flow actually lives.
const rawLiveMessagingConfig = window.avAppConfig && window.avAppConfig['live-messaging-flow'];
const liveMessagingFlowConfig = rawLiveMessagingConfig as LiveMessagingFlowConfig | undefined;
void initializeLiveMessaging(liveMessagingFlowConfig);

const parseLocale = (param?: string): string => {
  return param ? param.replace(/-/g, '_').toLocaleLowerCase() : DEFAULT_LOCALE;
};

const getTranslation = () => {
  const queryParams = qs.parse(window.location.search);
  const locale = parseLocale(queryParams.locale); // examples: de-de, it-it e.t.c.
  // @ts-ignore
  const vocabulary = translations[locale];
  return vocabulary ? vocabulary : translations[DEFAULT_LOCALE];
};

const translation = getTranslation();

// eslint-disable-next-line @typescript-eslint/ban-types
class App extends React.Component<{}> {
  public render() {
    return (
      <ThemeProvider theme="light">
        <TranslatorProvider translations={translation}>
          <VerificationJourney />
        </TranslatorProvider>
      </ThemeProvider>
    );
  }
}

render(<App />, document.getElementById('djv-root'));
